import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { AttendanceStatus, JournalStudent } from "../journal/types";

/** Bitta sessiyadagi o'quvchi davomati — ro'yxat ekrani ko'rsatadigan ko'rinishda. */
export interface RosterEntry {
  student: JournalStudent;
  status: AttendanceStatus;
  checkInAt: string | null;
  checkOutAt: string | null;
  durationMin: number;
  note: string | null;
}

export interface AttendanceSummaryRow {
  student: JournalStudent;
  heldSessions: number;
  present: number;
  late: number;
  excused: number;
  absent: number;
  attendancePercent: number;
}

/** Joriy o'quvchining o'z davomat qatorlaridan biri, sessiyasi bilan. */
export interface MyAttendanceRow {
  id: number;
  sessionId: number;
  status: AttendanceStatus;
  checkInAt: string | null;
  checkOutAt: string | null;
  durationMin: number;
  note: string | null;
  session: {
    id: number;
    title: string;
    scheduledDate: string;
    startTime: string;
    endTime: string | null;
  };
}

/**
 * LIVE kurslardagi davomat.
 *
 * Kundalik belgilash `JournalApi` orqali boradi (u yerda davomat va kundalik
 * baho bitta katakni bo'lishadi). Bu endpoint'lar esa faqat davomatga
 * qaraydigan ko'rinishlar uchun: bitta sessiyaning ro'yxati va kurs bo'yicha
 * foizlar.
 */
export class AttendanceApi extends BaseApi {
  private readonly baseUrl: string = "/attendance";

  /** Bitta sessiya ro'yxati — har bir o'quvchining davomati bilan. */
  getRoster(sessionId: number) {
    return this.request.get<RosterEntry[], ApiResponse<RosterEntry[]>>(
      `${this.baseUrl}/sessions/${sessionId}`,
    );
  }

  /** Kursda o'tkazilgan sessiyalar bo'yicha har bir o'quvchining davomat foizi. */
  getCourseSummary(courseId: number) {
    return this.request.get<AttendanceSummaryRow[], ApiResponse<AttendanceSummaryRow[]>>(
      `${this.baseUrl}/courses/${courseId}/summary`,
    );
  }

  /** O'quvchining o'zini qayd etishi (sessiya jonli bo'lishi shart). */
  checkIn(sessionId: number) {
    return this.request.post<unknown, ApiResponse<unknown>>(
      `${this.baseUrl}/sessions/${sessionId}/check-in`,
    );
  }

  checkOut(sessionId: number) {
    return this.request.post<unknown, ApiResponse<unknown>>(
      `${this.baseUrl}/sessions/${sessionId}/check-out`,
    );
  }

  /** Joriy o'quvchining kurs bo'yicha davomati. */
  getMine(courseId: number) {
    return this.request.get<MyAttendanceRow[], ApiResponse<MyAttendanceRow[]>>(
      `${this.baseUrl}/courses/${courseId}/me`,
    );
  }
}

export const attendanceApi = new AttendanceApi();
